export const GET_DETAIL_EXPERIENCE_REVIVE = 'GET_DETAIL_EXPERIENCE_REVIVE';
